module.exports = __webpack_public_path__ + "958c85259153ee82a28871849240cafb.png";